import { API_ENDPOINTS } from 'services/api';
import httpClient from 'services/httpClient';
import {
  CompetencyModuleDataListResponse,
  CompetencyModuleDetailResponse,
  CompetencyModuleJobFamilyDataListResponse,
  FormDataCreateCompetencyModule,
  FormDataDeleteCompetencyModule,
  FormDataUpdateCompetencyModule
} from 'types/dacum/moduleManagement';

interface Params {
  search?: string;
  pageNumber?: number;
  pageSize?: number;
  status?: string;
  sortBy?: string;
  startDate?: string;
  endDate?: string;
  schoolId?: string | null;
  sortOrder?: 'asc' | 'desc';
}

export const moduleManagementService = {
  createModule: async (data: FormDataCreateCompetencyModule) => {
    const response = await httpClient.post(API_ENDPOINTS.DACUM.MODULE_MANAGEMENT.ADD, data);
    return response.data;
  },
  updateModule: async (data: FormDataUpdateCompetencyModule) => {
    const response = await httpClient.put(API_ENDPOINTS.DACUM.MODULE_MANAGEMENT.UPDATE, data);
    return response.data;
  },
  deleteModule: async (data: FormDataDeleteCompetencyModule) => {
    const response = await httpClient.delete(API_ENDPOINTS.DACUM.MODULE_MANAGEMENT.DELETE, {
      data
    });
    return response.data;
  },
  detailModule: async (id: string) => {
    const response = await httpClient.get<CompetencyModuleDetailResponse>(
      `${API_ENDPOINTS.DACUM.MODULE_MANAGEMENT.DETAIL}/${id}`
    );
    return response.data;
  },
  getModuleCompetency: async (params?: Params): Promise<CompetencyModuleDataListResponse> => {
    const response = await httpClient.get<CompetencyModuleDataListResponse>(
      API_ENDPOINTS.DACUM.MODULE_MANAGEMENT.LIST,
      {
        params
      }
    );
    return response.data;
  },
  getModuleCompetencyJobFamily: async (
    params?: Params & { trCompetencyModuleID: string }
  ): Promise<CompetencyModuleJobFamilyDataListResponse> => {
    const response = await httpClient.get<CompetencyModuleJobFamilyDataListResponse>(
      `${API_ENDPOINTS.DACUM.MODULE_MANAGEMENT.JOB_FAMILY_LIST}/${params?.trCompetencyModuleID}`,
      {
        params: {
          pageSize: params?.pageSize,
          sortOrder: params?.sortOrder,
          pageNumber: params?.pageNumber
        }
      }
    );
    return response.data;
  },
  createModuleCompetencyJobFamily: async (data: {
    TrCompetencyModuleID: string;
    JobFamilyID: string;
  }): Promise<{
    message: string;
    data: {
      trCompetencyModuleJobFamilyID: string;
    };
  }> => {
    const response = await httpClient.post<{
      message: string;
      data: {
        trCompetencyModuleJobFamilyID: string;
      };
    }>(API_ENDPOINTS.DACUM.MODULE_MANAGEMENT.JOB_FAMILY_ADD, data);
    return response.data;
  },
  deleteModuleCompetencyJobFamily: async (data: {
    TrCompetencyModuleJobFamilyID: string;
  }): Promise<{
    message: string;
  }> => {
    const response = await httpClient.delete<{
      message: string;
    }>(API_ENDPOINTS.DACUM.MODULE_MANAGEMENT.JOB_FAMILY_DELETE, {
      data
    });
    return response.data;
  },
  // LIA Type options - assuming these are predefined
  getLIATypeOptions: () => {
    return [
      { value: 'assessment', label: 'Assessment' },
      { value: 'evaluation', label: 'Evaluation' },
      { value: 'survey', label: 'Survey' }
    ];
  }
};
